/**
 * Environment Detector
 * Detects whether the app is running in Tauri, Electron, or web browser mode
 */

/**
 * Check if running in Tauri environment
 * In Tauri 2.0, check for __TAURI_INTERNALS__ or __TAURI__
 */
export const isTauriMode = (): boolean => false;

/**
 * Check if running in a native desktop shell (Tauri or Electron)
 */
export const isDesktopMode = (): boolean => {
  return isTauriMode() || isElectronMode();
};

/**
 * Check if running in Electron environment
 * Electron apps run on localhost, 127.0.0.1, or file:// protocol
 */
export const isElectronMode = (): boolean => false;

/**
 * Back is the browser store site on every host, including localhost.
 */
export const isWebMode = (): boolean => true;

/**
 * Check if window.api is available (desktop IPC)
 */
export const hasElectronAPI = (): boolean => {
  return typeof window !== 'undefined' &&
         typeof (window as any).api !== 'undefined' &&
         typeof (window as any).api.invoke === 'function';
};

/**
 * Check if Tauri invoke is available
 */
export const hasTauriAPI = (): boolean => {
  return isTauriMode();
};

/**
 * Get environment name for logging
 */
export const getEnvironmentName = (): string => {
  if (isTauriMode()) {
    return hasElectronAPI() ? 'Tauri' : 'Tauri (API unavailable)';
  }
  if (isElectronMode()) {
    return hasElectronAPI() ? 'Electron' : 'Electron (API unavailable)';
  }
  return 'Web Browser';
};
